import { IConversation } from 'features/pi/model/Conversation';
import React from 'react';
import { useConversation } from 'features/pi/view/hooks/useConversation';
import { useUiManager } from 'features/pi/view/hooks/useUiManager';
import { ChatBubble } from 'features/pi/view/uiManager/text-instances/chat-bubble/chat-bubble';
import styles from './history-item.module.scss';
import { useAssistant } from 'features/pi/view/hooks/useAssistant';

export interface HistoryItemProps {
    conversation: IConversation;
    removeConversation: (conversationId: string) => void;
}

export const HistoryItem = ({ conversation, removeConversation }: HistoryItemProps) => {
    const { title, timestamp } = useConversation(conversation);
    const uiManager = useUiManager();
    const { deleteConversation } = useAssistant();

    return (
        <div onClick={() => uiManager.openConversation(conversation.getId())}>
            <ChatBubble
                text={title}
                timestampText={timestamp ? timestamp : undefined}
                additionalContainerClassName={styles.historyItem}
                textEditorContentClassName={styles.textEditor}
                onClickTrashIcon={async (e) => {
                    e.stopPropagation();
                    const isSuccess = await deleteConversation(conversation.getId());
                    if (isSuccess) {
                        removeConversation(conversation.getId());
                    }
                }}
            />
        </div>
    );
};
